import { NodeSpec } from "prosemirror-model";

export type IndentionNodeAttributesPart = {
	indention: number | undefined;
};

export type SetIndentionNodeAttributesPart = NonNullableProperties<IndentionNodeAttributesPart>;

export function parseIndention(htmlElement: HTMLElement): IndentionNodeAttributesPart {
	const inlineIndentionValue: string = htmlElement.style.marginLeft;

	return {
		indention: tryGetPixelsValue(inlineIndentionValue)
	};
}

export function generateIndentionStyles(attrs: IndentionNodeAttributesPart): {[key: string]: string;} {
	if (!attrs.indention) {
		return {};
	}

	return {
		"margin-left": `${attrs.indention}px`
	};
}

export type NodeSpecWithIndentionSupport = {
	doesSupportIndention: true;
};

export function doesSupportIndention(nodeType: NodeSpec): nodeType is (NodeSpec & NodeSpecWithIndentionSupport) {
	return (nodeType as NodeSpecWithIndentionSupport).doesSupportIndention === true;
}

export function isIndentionNodeAttributes(attrs: unknown): attrs is SetIndentionNodeAttributesPart {
	if (typeof attrs !== "object" || attrs === null) {
		return false;
	}

	return typeof (attrs as IndentionNodeAttributesPart).indention === "number";
}

function tryGetPixelsValue(size: string): number | undefined {
	const result: number = parseFloat(size);
	if (isNaN(result)) {
		return undefined;
	}

	return `${result}px` === size
		? result
		: undefined;
}